import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-action-menu',
    templateUrl: './action-menu.component.html',
    styleUrls: ['./action-menu.component.css'],
    standalone: false
})
export class ActionMenuComponent {

  @Input()
  linkTo: string;

  @Input()
  lableName: string;

}
